import * as React from "react";
import { utilLoca } from "../../utils/i18n/utilLoca";
export var SunsettingImages = function () { return (React.createElement("div", { className: "sunsetting--padded" },
    React.createElement(ClickableImage, { image: "BFNH_Sunset_androidPicture", link: "BFNH_Sunset_androidLink" }),
    React.createElement(ClickableImage, { image: "BFNH_Sunset_iosPicture", link: "BFNH_Sunset_iosLink" }),
    React.createElement(ClickableImage, { image: "BFNH_Sunset_amazonPicture", link: "BFNH_Sunset_amazonLink" }))); };
var ClickableImage = function (_a) {
    var image = _a.image, link = _a.link;
    var imageSrc = utilLoca.get(image);
    var translatedLink = utilLoca.get(link);
    return (React.createElement("a", { href: translatedLink, target: "_blank", rel: "noopener noreferrer" },
        React.createElement("img", { src: imageSrc, height: "47", width: "134" })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/sunsetting/SunsettingImages.tsx
// module id = 2934
// module chunks = 3